import dayjs from 'dayjs';
import { DayPicker } from 'react-day-picker';
import { Text } from 'preact-i18n';

import DayButtonWithBadge from './DayButtonWithBadge';
import ReturnOpenSwitch from './ReturnOpenSwitch';

const CalendarSection = ({
  sharedDayPickerProps,
  today,
  roundWithOpenSlot,
  useOneWaySingleMode,
  startDate,
  endDate,
  dayBadgeText,
  showTodayAccentHint,
  departureAvailability,
  returnAvailability,
  onDayWithPriceHover,
  handleRoundOpenSlotChange,
  handleOneWaySelect,
  handleRangeChange,
  handleTodayClick,
  onCloseClick,
  showOpenTicket,
  departureIsOpen,
  returnIsOpen,
  handleToggleOpenReturn,
  flatVariant,
}) => {
  const useSingleMode = roundWithOpenSlot || useOneWaySingleMode;

  return (
    <div className="udp-calendar-wrap">
      <DayPicker
        {...sharedDayPickerProps}
        today={today}
        components={{
          ...sharedDayPickerProps.components,
          DayButton: ({ day, modifiers, ...props }) => {
            const dateKey = dayjs(day.date).format('YYYY-MM-DD');
            const sourceAvailability = modifiers.range_end
              ? returnAvailability
              : departureAvailability;
            const dayData = sourceAvailability[dateKey] ?? null;
            return (
              <DayButtonWithBadge
                {...props}
                day={day}
                modifiers={modifiers}
                badgeText={dayBadgeText}
                showTodayAccentHint={showTodayAccentHint}
                dayData={dayData}
                onDayWithPriceHover={
                  onDayWithPriceHover
                    ? dayDataArg => onDayWithPriceHover(dateKey, dayDataArg)
                    : undefined
                }
              />
            );
          },
        }}
        mode={useSingleMode ? 'single' : 'range'}
        min={!useSingleMode ? 0 : undefined}
        selected={
          useSingleMode
            ? startDate || undefined
            : startDate || endDate
              ? endDate
                ? { from: startDate, to: endDate }
                : { from: startDate }
              : undefined
        }
        onSelect={
          roundWithOpenSlot
            ? handleRoundOpenSlotChange
            : useOneWaySingleMode
              ? handleOneWaySelect
              : handleRangeChange
        }
        resetOnSelect
      />

      <div className="udp-footer">
        <button
          type="button"
          className="udp-footer-btn udp-footer-btn--today"
          onClick={handleTodayClick}
        >
          <Text id="label.today" />
        </button>
        <button type="button" className="udp-footer-btn" onClick={onCloseClick}>
          <Text id="button.close" />
        </button>
      </div>

      {showOpenTicket && (startDate || departureIsOpen) && (
        <ReturnOpenSwitch
          returnIsOpen={returnIsOpen}
          handleToggleOpenReturn={handleToggleOpenReturn}
          flatVariant={flatVariant}
        />
      )}
    </div>
  );
};

export default CalendarSection;
